import React from 'react';
import GravityPaymentSettings from './gravityPaymentSettings';
import { useAppSelector } from 'app';
import { TargetPayPaymentGateway } from 'common/utils/shared/permission-extensions';
import AdyenPaymentSettings from './adyen-settings';

const PaymentSettings: React.FC = () => {

    const textToPayPaymentGateway = useAppSelector(
        (state) => state.user?.textToPayPaymentGateway
      );
    
      console.log({textToPayPaymentGateway});

    const renderSettings = () => {
        switch (textToPayPaymentGateway) {
          case TargetPayPaymentGateway.Gravity:
            return <GravityPaymentSettings />;
          case TargetPayPaymentGateway.Ayden:
            return <AdyenPaymentSettings />;
          default:
            return <GravityPaymentSettings />;
        }
      };

      return (renderSettings());
};

export default PaymentSettings;
